import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import produce from 'immer';
import FilterContext from './FilterContext';
import FilterItem from './FilterItem';
import FilterAddExpression from './FilterAddExpression';
var EXP_CACHE = {};

var getFromCache = function getFromCache(exp, idx) {
  if (EXP_CACHE[idx] && EXP_CACHE[idx].item === exp) return EXP_CACHE[idx];
  var toCache = {
    item: exp,
    type: 'expression',
    index: idx
  };
  EXP_CACHE[idx] = toCache;
  return toCache;
};
/**
 * @param {import('./types').EcrionFilterExpression[]} expressions
 */


var group = function group(expressions) {
  /**@type {import('./types').FilterExpressionItemType[]} */
  var out = [];
  var index = -1;
  expressions && expressions.forEach(function (expression) {
    if (!expression.Groups) {
      out.push(getFromCache(expression, ++index));
      return;
    }

    var group = expression.Groups.split('>')[0];
    var createItem = false;
    if (!out.length) createItem = true;

    if (!createItem) {
      /**@type {import('./types').FilterExpressionGroup} */
      // @ts-ignore
      var prevItem = out[out.length - 1] && out[out.length - 1].item;

      if (prevItem.Group && prevItem.Group === group) {
        prevItem.Expressions.push(expression);
        ++index;
      } else {
        createItem = true;
      }
    }

    if (createItem) {
      out.push({
        item: {
          Group: group,
          Expressions: [expression]
        },
        type: 'group',
        index: ++index
      });
    }
  });
  return out;
};

var useFilterState = function useFilterState(value, onChange) {
  var items = group(value.Expressions);
  var lastExpIdx = value && value.Expressions ? value.Expressions.length : 0;
  var on = React.useMemo(function () {
    var expChange = function expChange(newExpressionValue, _ref) {
      var expIdx = _ref.expIdx;
      return onChange(function (value) {
        return produce(value, function (draft) {
          draft.Expressions[expIdx] = _objectSpread({}, draft.Expressions[expIdx], newExpressionValue);
        });
      });
    };

    var expCombineChange = function expCombineChange(newExpressionCombineValue, _ref2) {
      var expIdx = _ref2.expIdx;
      return expChange({
        Combine: newExpressionCombineValue
      }, {
        expIdx: expIdx
      });
    };

    var expAdd = function expAdd(expIdx) {
      var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var newGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return onChange(function (value) {
        return produce(value || {
          Expressions: []
        }, function (draft) {
          if (newGroup === true) group = 'g' + Math.round(Math.random() * 10000);
          var newExp = {
            Combine: 'AND',
            Groups: group
          };

          if (expIdx === 0) {
            newExp = _objectSpread({}, newExp, {
              Field: 'Contact.CRMType',
              Op: 'Equal',
              Value: 'Lead'
            });
          } else {
            newExp = _objectSpread({}, newExp, {
              Field: 'Contact.Country',
              Op: 'Equal',
              Value: ''
            });
          }

          draft.Expressions.splice(expIdx + 1, 0, newExp);
        });
      });
    };

    var expAddLast = function expAddLast(newGroup) {
      return expAdd(lastExpIdx, '', newGroup);
    };

    var expDelete = function expDelete(_ref3) {
      var expIdx = _ref3.expIdx;
      onChange(function (value) {
        return produce(value, function (draft) {
          draft.Expressions.splice(expIdx, 1);
        });
      });
    };

    return {
      expChange: expChange,
      expCombineChange: expCombineChange,
      expAdd: expAdd,
      expAddLast: expAddLast,
      expDelete: expDelete
    };
  }, [onChange, lastExpIdx]);
  return {
    items: items,
    on: on
  };
};
/**
 * @param {import('./types').FormInputFilterProps} props
 */


var FilterFormInput = function FilterFormInput(_ref4) {
  var value = _ref4.value,
      onChange = _ref4.onChange,
      schema = _ref4.schema,
      disabled = _ref4.disabled,
      variant = _ref4.variant,
      color = _ref4.color;

  var _useFilterState = useFilterState(value, onChange),
      items = _useFilterState.items,
      on = _useFilterState.on;

  var context = React.useMemo(function () {
    return {
      schema: schema,
      disabled: disabled,
      variant: variant,
      color: color
    };
  }, [schema, disabled, variant, color]);
  return React.createElement(FilterContext.Provider, {
    value: context
  }, items.map(function (item, idx) {
    return React.createElement(FilterItem, {
      key: idx,
      item: item,
      isLast: idx === items.length - 1,
      onChange: on.expChange,
      onCombineChange: on.expCombineChange,
      onAdd: on.expAdd,
      onDelete: on.expDelete
    });
  }), React.createElement(FilterAddExpression, {
    group: true,
    onClick: on.expAddLast
  }));
};

FilterFormInput.defaultProps = {
  disabled: false,
  variant: 'filled',
  color: 'primary'
};
export default FilterFormInput;